"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.GetRealvalue = exports.setDefaultSortKey = exports.setSortObj = exports.gdzjc_chart = exports.ggcg_chart = exports.scgk_chart = void 0;
var utils_1 = __importDefault(require("../../src/modules/commonutil/utils"));
var webconfig = require('../../config/web');
function setSortObj(sort_name) {
    var sortObj = {
        sortname: {
            key: 'sortColumns',
            value: sort_name
        },
        desc: {
            sortkey: 'sortTypes',
            value: '-1'
        },
        asc: {
            sortkey: 'sortTypes',
            value: '1'
        },
        "default": {
            sortkey: 'sortTypes',
            value: '0'
        }
    };
    return sortObj;
}
exports.setSortObj = setSortObj;
function setDefaultSortKey(table) {
    var query_str = utils_1["default"].getQueryString('st');
    if (query_str) {
        var col_config = table.tablecolumns.config;
        col_config.forEach(function (t) {
            t.defaultsortType = "default";
            if (t.paramname && t.paramname.toLowerCase() == query_str.toLowerCase()) {
                t.defaultsortType = "desc";
            }
        });
    }
}
exports.setDefaultSortKey = setDefaultSortKey;
function GetRealvalue(v1, v2) {
    if (v1 === null || typeof v1 === "undefined")
        return v2;
    return v1;
}
exports.GetRealvalue = GetRealvalue;
function mergeArray(arr1, arr2) {
    var ind1 = 0; //标记arr1的对比元素的初始索引值
    var ind2 = 0; //标记arr2的对比元素的初始索引值
    var arr = []; //作为输出的新数组
    while (ind1 < arr1.length && ind2 < arr2.length) { //当arr1和arr2元素均未全部存入arr中，则从第一个元素开始进行比较，将较小的那个元素存入arr
        if (arr1[ind1] == arr2[ind2]) {
            arr.push(arr1.slice(ind1, ind1 + 1)[0]); //若arr1的对比元素等于arr2的对比元素，则将arr1的对比元素存入arr中
            ind1++;
            ind2++;
        }
        else if (arr1[ind1] < arr2[ind2]) {
            arr.push(arr1.slice(ind1, ind1 + 1)[0]); //若arr1的对比元素小于arr2的对比元素，则将arr1的对比元素存入arr中
            ind1++;
        }
        else {
            arr.push(arr2.slice(ind2, ind2 + 1)[0]);
            ind2++;
        }
    }
    while (ind1 < arr1.length) { //当arr2的元素已全部存入arr中，则直接将arr1剩余的所有元素依次存入arr
        arr.push(arr1.slice(ind1, ind1 + 1)[0]);
        ind1++;
    }
    while (ind2 < arr2.length) { //当arr1的元素已全部存入arr中,则直接将arr2剩余的所有元素依次存入arr
        arr.push(arr2.slice(ind2, ind2 + 1)[0]);
        ind2++;
    }
    return arr;
}
//市场概况图
var scgk_chart = {
    loadChart: function () {
        var that = this;
        this.chart_bar = echarts.init(document.getElementById('scgk_chart'));
        // if (pageData["SCGK_ChartData1"] && pageData["SCGK_ChartData2"]) {
        //     this.orgData(pageData["SCGK_ChartData1"], pageData["SCGK_ChartData2"]);
        // } else {
        //     this.getData();
        // }
        this.getData();
        $('#sc_type_radio input').change(function () {
            var data_type = $(this).data('type') || '';
            var time_type = $('#filter_type_ul li.at').data('type');
            that.getData(data_type, time_type);
        });
        $("#filter_type_ul li").on("click", function () {
            $("#filter_type_ul li").removeClass("at");
            $(this).addClass("at");
            var time_type = $(this).data("type");
            var $checkedType = $('#sc_type_radio input:checked');
            var data_type = $checkedType.data('type');
            that.getData(data_type, time_type);
        });
    },
    getData: function (data_type, time_type) {
        return __awaiter(this, void 0, void 0, function () {
            var that, now, start_date, d1, date_filter, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        now = new Date();
                        data_type = data_type || 'GFJE';
                        time_type = time_type || '1';
                        start_date = '';
                        if (time_type == '2') {
                            start_date = "2010-01";
                        }
                        else if (time_type == '3') {
                            start_date = "2005-01";
                        }
                        else {
                            d1 = new Date();
                            d1.setMonth(d1.getMonth() - 2);
                            start_date = utils_1["default"].dateFormat(d1, "YYYY-MM-DD");
                        }
                        date_filter = start_date == '' ? '' : '(TDATE>=\'' + start_date + '\')';
                        params = {
                            reportName: 'RPTA_WEB_GGSCTJ',
                            columns: 'ALL',
                            token: '28dfeb41d35cc81d84b4664d7c23c49f',
                            pageNumber: 1,
                            pageSize: 500,
                            sortColumns: 'TDATE',
                            sortTypes: 1,
                            filter: "(TYPE=\"" + time_type + "\")" + date_filter
                        };
                        return [4 /*yield*/, $.ajax({
                                url: webconfig.getWebPath('datacenter') + "api/data/v1/get",
                                dataType: "jsonp",
                                data: params
                            }).then(function (data1) {
                                if (data1) {
                                    params.reportName = 'RPTA_WEB_GDSCTJ';
                                    $.ajax({
                                        url: webconfig.getWebPath('datacenter') + "api/data/v1/get",
                                        dataType: "jsonp",
                                        data: params
                                    }).then(function (data2) {
                                        that.orgData(data1, data2, data_type, time_type);
                                    });
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    orgData: function (data1, data2, data_type, time_type) {
        var that = this;
        that.XData = [];
        that.YData = [];
        that.chart_bar.showLoading({
            text: '图表加载中...' //loading
        });
        data_type = data_type || 'GFJE';
        time_type = time_type || '1';
        var ydata1 = [], ydata2 = [], ydata3 = [], ydata4 = [], ydata5 = [];
        var dates = [];
        var chartData1 = data1 && data1.result && data1.result.data;
        var chartData2 = data2 && data2.result && data2.result.data;
        var alldata = {};
        if (chartData1 && chartData2) {
            chartData1.forEach(function (item) {
                var date = utils_1["default"].dateFormat(item.TDATE, "YYYY-MM-DD");
                if (alldata[date]) {
                    alldata[date].ggzc = item["ZC" + data_type];
                    alldata[date].ggjc = item["JC" + data_type];
                    alldata[date]["new"] = item['NEW'];
                }
                else {
                    alldata[date] = {
                        date: date,
                        ggzc: item["ZC" + data_type],
                        ggjc: item["JC" + data_type],
                        "new": item["NEW"]
                    };
                }
            });
            chartData2.forEach(function (item) {
                var date = utils_1["default"].dateFormat(item.TDATE, "YYYY-MM-DD");
                if (alldata[date]) {
                    alldata[date].gdzc = item["ZC" + data_type];
                    alldata[date].gdjc = item["JC" + data_type];
                }
                else {
                    alldata[date] = {
                        date: date,
                        gdzc: item["ZC" + data_type],
                        gdjc: item["JC" + data_type],
                        "new": item["NEW"]
                    };
                }
            });
            var list = [];
            for (var key in alldata) {
                if (Object.prototype.hasOwnProperty.call(alldata, key)) {
                    list.push(alldata[key]);
                }
            }
            list.sort(function (a, b) {
                return parseInt(utils_1["default"].dateFormat(a.date, "YYYYMMDD")) > parseInt(utils_1["default"].dateFormat(b.date, "YYYYMMDD")) ? 1 : -1;
            });
            list.forEach(function (item) {
                if (item["new"]) {
                    dates.push(item.date);
                    ydata1.push(utils_1["default"].toFixed2(item.ggzc / 1e4));
                    ydata2.push(utils_1["default"].toFixed2(item.ggjc / 1e4));
                    ydata3.push(utils_1["default"].toFixed2(item.gdzc / 1e4));
                    ydata4.push(utils_1["default"].toFixed2(item.gdjc / 1e4));
                    ydata5.push(utils_1["default"].toFixed2(item["new"]));
                }
            });
            that.XData = dates;
            that.YData.push(ydata1);
            that.YData.push(ydata2);
            that.YData.push(ydata3);
            that.YData.push(ydata4);
            that.YData.push(ydata5);
            that.showChart();
        }
        else {
            that.chart_bar.hideLoading();
        }
    },
    showChart: function () {
        var that = this;
        var dw_name = $('#sc_type_radio input:checked').next("label").data("name") || '元';
        // 指定图表的配置项和数据
        var option = {
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                left: 'center'
                //selectedMode: false
            },
            dataZoom: [
                {
                    type: "slider",
                    show: true,
                    showDetail: true,
                    filterMode: "empty",
                    start: 70,
                    end: 100
                },
                { type: "inside" }
            ],
            //grid: {
            //    x: '6%',
            //    y: '15%',
            //    width: '88%',
            //    height: '55%'
            //},
            xAxis: {
                type: 'category',
                data: that.XData,
                //axisLine: {
                //    lineStyle: {
                //        color: '#4488BB',
                //        width: 2
                //    }
                //},
                axisTick: { show: false },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    textStyle: {
                        color: '#000'
                    }
                }
            },
            yAxis: [
                {
                    type: 'value',
                    scale: true,
                    name: '单位：' + dw_name,
                    nameTextStyle: {
                        color: '#000'
                    },
                    //axisLine: {
                    //    lineStyle: {
                    //        color: '#4488BB',
                    //        width: 2
                    //    }
                    //},
                    axisTick: { show: false },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#E6E6E6"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        }
                        //formatter: function (value, index) {
                        //    return value + "万";
                        //}
                    }
                },
                {
                    type: 'value',
                    //name: "沪深300指数",
                    scale: true,
                    //axisLine: {
                    //    lineStyle: {
                    //        color: '#4488BB',
                    //        width: 2
                    //    }
                    //},
                    axisTick: { show: false },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#E6E6E6"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        }
                    }
                }
            ],
            series: [
                {
                    name: "高管增持",
                    data: that.YData[0],
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    barGap: 0,
                    color: '#d32f2f',
                    type: 'bar'
                },
                {
                    name: "高管减持",
                    data: that.YData[1],
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    color: '#4caf50',
                    type: 'bar'
                },
                {
                    name: "股东增持",
                    data: that.YData[2],
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    color: '#fbc02d',
                    type: 'bar'
                },
                {
                    name: "股东减持",
                    data: that.YData[3],
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    color: '#90a4ae',
                    type: 'bar'
                },
                {
                    name: "沪深300指数（右）",
                    data: that.YData[4],
                    yAxisIndex: 1,
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    color: '#ab47bc',
                    type: 'line'
                }
            ]
        };
        // 使用刚指定的配置项和数据显示图表
        that.chart_bar.setOption(option);
        that.chart_bar.hideLoading();
    }
};
exports.scgk_chart = scgk_chart;
//高管持股变动排名图
var ggcg_chart = {
    loadChart: function (deftype) {
        return __awaiter(this, void 0, void 0, function () {
            var that;
            return __generator(this, function (_a) {
                that = this;
                this.chart_bar = echarts.init(document.getElementById('ggcgbd_chart'));
                this.getData(deftype);
                $("#gg_type_ul li").on("click", function () {
                    $("#gg_type_ul li").removeClass("at");
                    $(this).addClass("at");
                    var zcjz_type = $(this).data('type');
                    var data_type = $('#gg_type_radio input:checked').data('type');
                    var time_type = $('#gg_time_radio input:checked').data('type');
                    that.getData(zcjz_type, data_type, time_type);
                });
                $('#gg_type_radio input').change(function () {
                    var data_type = $(this).data('type') || '';
                    //var name = $(this).next("label").data("name");
                    var zcjz_type = $("#gg_type_ul li.at").data('type');
                    var time_type = $('#gg_time_radio input:checked').data('type');
                    that.getData(zcjz_type, data_type, time_type);
                });
                $('#gg_time_radio input').change(function () {
                    var time_type = $(this).data('type') || '';
                    var data_type = $('#gg_type_radio input:checked').data('type');
                    var zcjz_type = $("#gg_type_ul li.at").data('type');
                    //var data_type = $checkedType.data('type');
                    //var name = $checkedType.next("label").data("name");
                    that.getData(zcjz_type, data_type, time_type);
                });
                return [2 /*return*/];
            });
        });
    },
    getData: function (zcjc_type, data_type, time_type) {
        if (zcjc_type === void 0) { zcjc_type = '1'; }
        if (data_type === void 0) { data_type = 'GFJE'; }
        if (time_type === void 0) { time_type = '1'; }
        return __awaiter(this, void 0, void 0, function () {
            var that, now, param, sort, color, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        now = new Date();
                        param = '';
                        sort = '', color = '';
                        param += '(type="' + time_type + '")';
                        if (zcjc_type == '1') {
                            param += '(' + data_type + '>=0)';
                            sort = '&sortColumns=' + data_type + '&sortTypes=-1';
                            color = '#d32f2f';
                        }
                        else {
                            param += '(' + data_type + '<0)';
                            sort = '&sortColumns=' + data_type + '&sortTypes=1';
                            color = '#4caf50';
                        }
                        url = webconfig.getWebPath('datacenter') + 'api/data/v1/get?reportName=RPTA_WEB_GGGGLB&columns=ALL&token=28dfeb41d35cc81d84b4664d7c23c49f&pageNumber=1&pageSize=10' + sort + '&filter=' + encodeURIComponent(param);
                        return [4 /*yield*/, $.ajax({
                                url: url,
                                dataType: "jsonp"
                            }).then(function (data) {
                                that.orgData(data, data_type, color);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    orgData: function (data, data_type, color) {
        var that = this;
        that.chart_bar.showLoading({
            text: '图表加载中...' //loading
        });
        that.XData = [];
        that.YData = [];
        var num = 2;
        color = color || '#d32f2f';
        data_type = data_type || 'GFJE';
        var chartData = data.result && data.result.data;
        if (chartData) {
            for (var i = 0; i < chartData.length; i++) {
                var item = chartData[i];
                that.XData.push(item.SNAME);
                that.YData.push(utils_1["default"].toFixed2(Math.abs(item[data_type]), num));
            }
        }
        that.showChart(color);
    },
    showChart: function (color) {
        var that = this;
        //var yAxisName = type === 'PEG1' ? "单位:(*0.0001)" : "";
        var gg_type = $('#gg_type_radio input:checked').data("type");
        var dw_name = gg_type == "GFSL" ? "股" : "元";
        var titleName = "个股" + $("#gg_type_ul li.at").data('name') + $('#gg_type_radio input:checked').next("label").data("name");
        // 指定图表的配置项和数据
        var option = {
            title: {
                text: titleName + "排序",
                left: 'center'
            },
            tooltip: {
                formatter: function (data) {
                    var str = data.marker + '<span style ="display:inline-block;width:125px;" >' + utils_1["default"].getTextValOrEmpty(data.name) + ':' + utils_1["default"].numFormat(data.value) + '</span>';
                    return str;
                }
            },
            legend: {
            //data: ['销量']
            },
            xAxis: {
                data: that.XData,
                axisTick: { show: false },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    textStyle: {
                        color: '#000'
                    }
                }
            },
            yAxis: {
                name: '单位：' + dw_name,
                axisTick: { show: false },
                splitLine: {
                    show: true,
                    lineStyle: {
                        type: 'dotted',
                        color: "#E6E6E6"
                    }
                },
                axisLabel: {
                    formatter: function (value, index) {
                        return utils_1["default"].numFormat(value);
                    }
                }
            },
            series: [{
                    type: 'bar',
                    barWidth: 40,
                    color: color,
                    data: that.YData
                }]
        };
        // 使用刚指定的配置项和数据显示图表。
        that.chart_bar.setOption(option);
        that.chart_bar.hideLoading();
    }
};
exports.ggcg_chart = ggcg_chart;
//股东增减持股变动排名图
var gdzjc_chart = {
    loadChart: function (deftype) {
        var that = this;
        this.chart_bar = echarts.init(document.getElementById('gdzjc_chart'));
        // if (pageData["GDZJC_ChartData"] && pageData["GDZJC_ChartData"].result) {
        //     this.orgData(pageData["GDZJC_ChartData"]);
        // } else {
        //     this.getData();
        // }
        this.getData(deftype);
        $("#gd_type_ul li").on("click", function () {
            $("#gd_type_ul li").removeClass("at");
            $(this).addClass("at");
            var zcjz_type = $(this).data('type');
            var data_type = $('#gd_type_radio input:checked').data('type');
            var time_type = $('#gd_time_radio input:checked').data('type');
            that.getData(zcjz_type, data_type, time_type);
        });
        $('#gd_type_radio input').change(function () {
            var data_type = $(this).data('type') || '';
            var zcjz_type = $("#gd_type_ul li.at").data('type');
            var time_type = $('#gd_time_radio input:checked').data('type');
            that.getData(zcjz_type, data_type, time_type);
        });
        $('#gd_time_radio input').change(function () {
            var time_type = $(this).data('type') || '';
            var data_type = $('#gd_type_radio input:checked').data('type');
            var zcjz_type = $("#gd_type_ul li.at").data('type');
            that.getData(zcjz_type, data_type, time_type);
        });
    },
    getData: function (zcjc_type, data_type, time_type) {
        if (zcjc_type === void 0) { zcjc_type = '1'; }
        if (data_type === void 0) { data_type = 'GFJE'; }
        if (time_type === void 0) { time_type = '1'; }
        return __awaiter(this, void 0, void 0, function () {
            var that, now, param, sort, color, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        now = new Date();
                        data_type = data_type;
                        zcjc_type = zcjc_type;
                        param = '';
                        sort = '', color = '';
                        time_type = time_type;
                        param += '(TYPE="' + time_type + '")';
                        if (zcjc_type == '1') {
                            param += '(' + data_type + '>=0)';
                            sort = '&sortColumns=' + data_type + '&sortTypes=-1';
                            color = '#d32f2f';
                        }
                        else {
                            param += '(' + data_type + '<0)';
                            sort = '&sortColumns=' + data_type + '&sortTypes=1';
                            color = '#4caf50';
                        }
                        url = webconfig.getWebPath('datacenter') + 'api/data/v1/get?reportName=RPTA_WEB_GDGGLB&columns=ALL&token=28dfeb41d35cc81d84b4664d7c23c49f&pageNumber=1&pageSize=10' + sort + '&filter=' + encodeURIComponent(param);
                        return [4 /*yield*/, $.ajax({
                                url: url,
                                dataType: "jsonp"
                            }).then(function (data) {
                                that.orgData(data, data_type, color);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    orgData: function (data, data_type, color) {
        var that = this;
        that.chart_bar.showLoading({
            text: '图表加载中...' //loading
        });
        that.XData = [];
        that.YData = [];
        var num = 2;
        color = color || '#d32f2f';
        data_type = data_type || 'GFJE';
        var chartData = data.result && data.result.data;
        if (chartData) {
            for (var i = 0; i < chartData.length; i++) {
                var item = chartData[i];
                var multi = data_type == 'GFSL' ? 10000 : 1;
                that.XData.push(item.SNAME);
                that.YData.push(utils_1["default"].toFixed2(Math.abs(item[data_type] * multi), num));
            }
        }
        that.showChart(color);
    },
    showChart: function (color) {
        var that = this;
        var gd_type = $('#gd_type_radio input:checked').data("type");
        var dw_name = gd_type == "GFSL" ? "股" : "元";
        var titleName = "个股" + $("#gd_type_ul li.at").data('name') + $('#gd_type_radio input:checked').next("label").data("name");
        // 指定图表的配置项和数据
        var option = {
            title: {
                text: titleName + "排序",
                left: 'center'
            },
            tooltip: {
                formatter: function (data) {
                    var str = data.marker + '<span style ="display:inline-block;width:125px;" >' + utils_1["default"].getTextValOrEmpty(data.name) + ':' + utils_1["default"].numFormat(data.value, 2) + '</span>';
                    return str;
                }
            },
            xAxis: {
                data: that.XData,
                axisTick: { show: false },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    textStyle: {
                        color: '#000'
                    }
                }
            },
            yAxis: {
                name: '单位：' + dw_name,
                axisTick: { show: false },
                splitLine: {
                    show: true,
                    lineStyle: {
                        type: 'dotted',
                        color: "#E6E6E6"
                    }
                },
                axisLabel: {
                    formatter: function (value, index) {
                        return utils_1["default"].numFormat(value);
                    }
                }
            },
            series: [{
                    type: 'bar',
                    color: color,
                    barWidth: 40,
                    data: that.YData
                }]
        };
        // 使用刚指定的配置项和数据显示图表。
        that.chart_bar.setOption(option);
        that.chart_bar.hideLoading();
    }
};
exports.gdzjc_chart = gdzjc_chart;
//个股查询框
var sugitem = new suggest2017({
    filter: {
        markettype: '',
        mktnum: '',
        jys: '',
        classify: '',
        securitytype: '1,2,25'
    },
    showblank: false,
    offset: { left: -135, top: 0 },
    modules: ["stock"],
    width: 280,
    showstocklink: false,
    inputid: 'gdgg_StockCode',
    placeholder: '输代码、名称或简拼',
    onSubmit: function (result) {
        if (result.stock) {
            var type = $("#selector").val();
            var url = "";
            if (type == "1") {
                url = "/gdggcg/ggdetail/" + result.stock.Code + ".html";
            }
            else {
                url = "/gdggcg/gddetail/" + result.stock.Code + ".html";
            }
            window.open(url);
        }
        else {
            alert("请输入所查询股票的代码!");
        }
        return false;
    },
    onConfirmStock: function (result) {
        var type = $("#selector").val();
        var url = "";
        if (type == "1") {
            url = "/gdggcg/ggdetail/" + result.stock.Code + ".html";
        }
        else {
            url = "/gdggcg/gddetail/" + result.stock.Code + ".html";
        }
        window.open(url);
        return false;
    }
});
